import { gql } from '@apollo/client';
import { EngagementNotificationSettingFields } from './fragments';

export const SET_ENGAGEMENT_NOTIFICATION_SETTING = gql`
  mutation SetEngagementNotificationSetting(
    $input: SetEngagementNotificationSettingInput!
  ) {
    setEngagementNotificationSetting(input: $input) {
      ...EngagementNotificationSettingFields
    }
  }
  ${EngagementNotificationSettingFields}
`;
